<template lang="pug">
.card.mb-0
  //- small {{ memberID }}
  template(v-if="isMemberDetails")
    memberdetails
  template(v-else)
    .card-header
      .row.w-100
        .form-group.col-md-5.col-4.mb-1
          template(v-if="searchByMember")
            b-input-group(size="sm")
              b-form-select.col-4(v-model="searchType" size="sm" @change="initSearchData()")            
                option(value="account_id") {{ $t("ui.account_id") }}
                option(value="full_name") {{ $t("ui.full_name") }}
                option(value="contact_phone") {{ $t("ui.contact_phone") }}
                option(value="signup_ip") {{ $t("ui.signup_ip") }}
                option(value="referral_code") {{ $t("ui.referral_code") }}
                option(value="vip") {{ $t("ui.vip") }}
                option(value="second_id") {{ $t("ui.second_id") }}
              template(v-if="!['vip'].includes(searchType)")
                DebounceInput(autofocus type="text" v-model="searchData" :placeholder="$t('message.search_by_' + searchType)" @enter="getMemberList(true)" size="sm")
              template(v-else)
                VipLookup(
                  ref="vip_id"
                  required
                  type="array"
                  :dirty="$v.vip_id.$dirty"
                  :error="$v.vip_id.$error"
                  v-model.trim.lazy="$v.vip_id.$model"
                  :disabled="loading"
                  size="sm"
                  :operatorID="operatorID"
                  @input="getMemberList(true)"
                )
                ValidateResult(:value="$v.vip_id" :name="$tc('ui.vip')")
          template(v-else)
            DateRangePicker(:value="dateRange" @update="getData")
        .form-group.col-12(v-if="!['vip'].includes(searchType)")
          b-input-group(size="sm")
            b-input-group-text(slot="prepend" :title="$t('ui.search_by_member')")
              //- span {{ $t('ui.search_by_member') }}
              i.fas.fa-users
            b-input-group-text(slot="append")
              label.custom-switch
                input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="searchByMember" @input="resetInput()")
                span.custom-switch-indicator      
        .form-group.col-12
          SubmitButton(
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getMemberList(true)"
            variant="primary"
            size="sm"
          ).mr-2

          //- jsonToExcelFull(v-if="memberListFull.length > 0" mode="MemberList" tbl="tblMemberFull" :date="dateRange" btnTxt="export_member_all" type="0" :loading2="loading2")
          //- memberListExportFull(v-if="memberListFull.length > 0" :tbl="memberListFull")
          jsonToExcel(v-if="memberList.length > 0" mode="MemberList" tbl="tblList" :date="dateRange" btnTxt="export_one")
    .card-body
      .row
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRow"
            :per-page="getPageSize"
            v-model="currentPage"
            @input="changedPage($event)")
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
        .col-12 
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
              thead.thead-light
                tr
                  th.text-center(width="2%")
                    span #
                  th(width="7%" @click="sortOrder('account_id')")
                    span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                    .float-right
                      i(:class="changeSortKey('account_id')")
                  th(width="7%" @click="sortOrder('second_id')")
                    span(:title="$t('ui.second_id')") {{ $t('ui.second_id') }}
                    .float-right
                      i(:class="changeSortKey('second_id')")
                  th(width="6%" @click="sortOrder('contact_phone')")
                    span(:title="$t('ui.details')") {{ $t("ui.details") }}
                    .float-right
                      i(:class="changeSortKey('contact_phone')")
                  th(width="5%")
                    span(:title="$t('ui.vip_name')") {{ $t("ui.vip") }}
                  th(width="5%")
                    span(:title="$t('ui.ip')") {{ $t("ui.ip") }}                
                  th.text-right(width="5%" @click="sortOrder('game_balance')")
                    span(:title="$t('ui.balance')") {{ $t("ui.balance") }}
                    .float-right
                      i(:class="changeSortKey('game_balance')")
                  th.text-right(width="6%")
                    span(:title="$t('ui.ftd_amount')") {{ $t("ui.ftd_amount") }}
                  th(width="5%")
                    span(:title="$t('ui.upline')") {{ $t("ui.upline") }}
                  th(width="5%")
                    span(:title="$t('ui.referral_code')") {{ $t("ui.referral_code") }}
                  th.text-center(width="4%")
                    span(:title="$t('ui.downline')") {{ $t("ui.downline") }}
                  th(width="5%")
                    span(:title="$t('ui.affiliate')") {{ $t("ui.affiliate") }}
                  th.text-center(width="4%" @click="sortOrder('status')")
                    span(:title="$t('ui.status')") {{ $t("ui.status") }}
                    .float-right
                      i(:class="changeSortKey('status')")
                  th.text-right(width="7%" @click="sortOrder('created_date')")
                    span {{ $t("ui.created_date") }}
                    .float-right
                      i(:class="changeSortKey('created_date')")
              tbody.clusterize-content
                tr(v-if="memberList.length == 0")
                  td(:colspan="isEditAccess && !isOperator ? '15' : '14'").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in memberList" :class="$helpers.rowClass(item)")
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    span.d-block(:title="item.account_id")
                      b-link.text-decoration-none(href="javascript:void(0);" @click="onInfo(item)") {{ item.account_id }}
                    span.small(:title='item.account_verified ? $t("ui.verified") : $t("ui.unverified")')
                      i.fa.fa-sm(:class="{ 'fa-check text-primary' : item.account_verified, 'fa-times text-warning' : !item.account_verified }")
                  td
                    span(:title="item.second_id") {{ item.second_id }}
                  td
                    span.small.d-block(:title="item.contact_phone") {{ item.contact_phone }}
                    span.small.d-block(:title="item.contact_email") {{ item.contact_email }}
                    span.small.d-block(:title="item.full_name") {{ item.full_name }}
                    span.small.d-block(:title="$moment(item.dob).format('YYYY-MM-DD')") {{ item.dob ? $moment(item.dob).format('YYYY-MM-DD') : null }}
                  td
                    span(:title="item.vip_name") {{ item.vip_name }}
                  td
                    span(:title="item.signup_ip") {{ item.signup_ip }}
                  td.text-right
                    span.d-block.font-weight-bold(:class="$helpers.fontClassName(item.game_balance)" :title="$n(item.game_balance, 'currency')") {{ $n(item.game_balance, 'currency') }}
                    span.small.d-block.font-weight-bold(:class="{'text-danger': item.outstanding_balance < 0  }" v-if="item.outstanding_balance != 0 && item.outstanding_balance != null" :title="$n(item.outstanding_balance, 'currency')") ({{ $n(item.outstanding_balance, 'currency') }})
                  td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.ftd_amount)" :title="item.ftd_amount != null ? $n(item.ftd_amount, 'currency') : item.ftd_amount") {{ item.ftd_amount != null ? $n(item.ftd_amount, 'currency') : item.ftd_amount }}
                  td
                    span(:title="item.referrer_id") {{ item.referrer_id }}
                  td
                    span(:title="item.referral_code") {{ item.referral_code }}
                  td.text-center
                    span.font-weight-bold(:title="$n(item.referee_count_confirm, 'integer')") {{ $n(item.referee_count_confirm, 'integer') }}
                  td
                    span(:title="item.affiliate_id") {{ item.affiliate_id }}
                  td.text-center
                    span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                  td.text-right
                    span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ formatDate(item.created_date) }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import VipLookup from "@/library/VipLookup";
import ValidateResult from "@/library/ValidateResult";
import { required, requiredIf } from "vuelidate/lib/validators";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

import memberdetails from "@/components/member/new/memberDetails.vue";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";
// import memberListExportFull from "@/components/operatorTab/memberListExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    memberdetails,
    VipLookup,
    ValidateResult,
    jsonToExcelFull,
    // memberListExportFull,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    loading2: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    searchType: "account_id",
    searchData: null,
    memberList: [],
    memberListFull: [],
    editSelectedMember: null,
    editSelectedMemberId: "",
    sortKey: "account_id",
    sortType: "asc",
    searchType: "account_id",
    searchByMember: true,
    dateRange: {
      startDate: null,
      endDate: null
    },
    vip_id: "",
    isMemberDetails: false,
    sortBalance: false,
    sortBalanceCooldown: false,
    sortBalanceCooldownTimer: null
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMember;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    memberID() {
      return this.$store.getters.selectedMemberID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_memberlist");
    }
  },
  // watch: {
  //   memberID: {
  //     handler(newVal) {
  //       if (newVal) {
  //         this.isMemberDetails = true;
  //         this.searchData = this.memberID;
  //       } else {
  //         this.isMemberDetails = false;
  //         this.searchData = null;
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  mounted() {
    // Check on load if redirected from pendingTicket
    this.$nextTick(() => {
      if (this.memberID) {
        this.isMemberDetails = true;
        this.searchData = this.memberID;
      } else {
        this.isMemberDetails = false;
        this.searchData = null;
      }
    }); 

    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
  },  
  validations: {
    vip_id: {
      required: requiredIf(function () {
        return ['vip'].includes(this.searchType);
      })
    },
  },
  destroyed: function() {
    if (this.sortBalanceCooldownTimer) clearTimeout(this.sortBalanceCooldownTimer);
    this.$store.dispatch("user/setSelectedMemberID", null);
  },
  methods: {
    refresh() {
      // this.$store.dispatch("user/setSelectedMemberID", null);
      this.isMemberDetails = false;
      this.searchData = null;
      this.sortBalance = false;
      this.getMemberList();
    },
    refreshSortBalance() {
      this.isMemberDetails = false;
      this.sortBalance = true;
      this.getMemberList();
    },
    formatDate(date) {
      return date ? this.$moment(date).format('YYYY-MM-DD, HH:mm:ss') : null;
    },
    sortOrder(key) {
      if (key === 'game_balance') {
        if (this.sortBalanceCooldown) return;
        this.sortBalance = true;
        this.sortBalanceCooldown = true;
        if (this.sortBalanceCooldownTimer) clearTimeout(this.sortBalanceCooldownTimer);
        this.sortBalanceCooldownTimer = setTimeout(() => {
          this.sortBalanceCooldown = false;
          this.sortBalanceCooldownTimer = null;
        }, 30000);
      } else {
        this.sortBalance = false;
      }

      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getMemberList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    initSearchData() {
      if(!['vip'].includes(this.searchType)) {
        this.searchData = null;
        this.memberListFull = [];
      } else {
        this.vip_id = "";
        this.memberListFull = [];
      }

      this.getMemberList(true)
    },
    resetInput() {
      this.memberList = [];
      this.totalRow = 0;
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.searchData = null;
      this.searchType = "account_id";
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getMemberList(true);
    },
    onInfo(e) {
      this.isMemberDetails = true;      
      this.$store.dispatch("user/setSelectedMemberID", e.account_id);
    },
    checkMemberSearchCriteria: function () {
      if (this.searchData) {
        if (this.searchType == "full_name" && this.searchData.trim().length < 3) {
          return false;
        }

        if (this.searchType == "account_id" && this.searchData.trim().length < 3) {
          return false;
        }
      }

      return true;
    },
    getMemberList: function(isSearch) {
      // this.$store.dispatch("user/setSelectedMemberID", null);
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.checkMemberSearchCriteria()) {
          let url = config.memberListUrl();

          if (isSearch) this.currentPage = 1;

          var json = {
            action_by: this.$store.getters.loginId,
            auth_token: this.$store.getters.sessionToken,
            operator_id: this.operatorID,
            sort_key: this.sortKey,
            sort_type: this.sortType,
            page_number: this.currentPage,
            page_size: this.getPageSize,
            vip_id: this.searchType == 'vip' ? this.vip_id : null
          };

          if(this.sortBalance) {
            this.currentPage = 1;
            json.page_number = this.currentPage;
            json.member_id = null;
            json.full_name = null;
            json.contact_phone = null;
            json.signup_ip = null;
            json.referral_code = null;
            json.sort_balance = true;
          } else {
            json.sort_balance = false;
            if (this.searchByMember == true) {
              if (this.searchData) {
                if (this.searchType == "account_id") {
                  json.member_id = this.searchData;
                } else if (this.searchType == "full_name") {
                  json.full_name = this.searchData;
                } else if (this.searchType == "contact_phone") {
                  json.contact_phone = this.searchData;
                } else if (this.searchType == "signup_ip") {
                  json.signup_ip = this.searchData;
                } else if (this.searchType == "referral_code") {
                  json.referral_code = this.searchData;
                } else if (this.searchType == "second_id") {
                  json.second_id = this.searchData;
                }
              }
            } else {
              json.start_date = this.dateRange.startDate;
              json.end_date = this.dateRange.endDate;
            }
          }

          this.loading = true;
          this.$http.post(url, json).then(
            function(response) {
              this.loading = false;
              // Success
              try {
                if (response) {
                  this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                  this.feedback.status = response.data.statusdesc;
                  if (this.feedback.success == true) {
                    if(this.sortBalance) this.sortBalance = false;
                    this.memberList = response.data.dt;
                    this.totalRow = this.memberList.length > 0 ? this.memberList[0].totalrows : 0;
                    if (this.searchType == "vip") {
                      this.getMemberListFull(true);
                    }
                  } else {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              } catch (error) {
                this.feedback.success = false;
                this.feedback.status = errorTags.request.failed;
                this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            },
            function(response) {
              this.loading = false;
              // Error
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          );
        }
        else {
          this.totalRow = 0;
          this.memberList = [];
          if (this.searchType == "full_name")
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.fullNameMinThreeChar"), "error");
          else if (this.searchType == "account_id")
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.accountIdMinThreeChar"), "error");
        }
      }
    },
    getMemberListFull: function(isSearch) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.checkMemberSearchCriteria()) {
          let url = config.memberListUrl();

          if (isSearch) this.currentPage = 1;

          var json = {
            action_by: this.$store.getters.loginId,
            auth_token: this.$store.getters.sessionToken,
            operator_id: this.operatorID,
            sort_key: this.sortKey,
            sort_type: this.sortType,
            page_number: this.currentPage,
            page_size: -1,
            vip_id: this.searchType == 'vip' ? this.vip_id : null,
            sort_balance: false
          };

          if (this.searchByMember == true) {
            if (this.searchData) {
              if (this.searchType == "account_id") {
                json.member_id = this.searchData;
              } else if (this.searchType == "full_name") {
                json.full_name = this.searchData;
              } else if (this.searchType == "contact_phone") {
                json.contact_phone = this.searchData;
              } else if (this.searchType == "signup_ip") {
                json.signup_ip = this.searchData;
              } else if (this.searchType == "referral_code") {
                json.referral_code = this.searchData;
              }
            }
          } else {
            json.start_date = this.dateRange.startDate;
            json.end_date = this.dateRange.endDate;
          }

          this.loading2 = true;
          this.$http.post(url, json).then(
            function(response) {
              this.loading2 = false;
              // Success
              try {
                if (response) {
                  this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                  this.feedback.status = response.data.statusdesc;
                  if (this.feedback.success == true) {
                    this.memberListFull = response.data.dt;
                  } else {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              } catch (error) {
                this.feedback.success = false;
                this.feedback.status = errorTags.request.failed;
                this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            },
            function(response) {
              this.loading2 = false;
              // Error
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          );
        } else {
          this.memberListFull = [];
          if (this.searchType == "full_name")
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.fullNameMinThreeChar"), "error");
          else if (this.searchType == "account_id")
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.accountIdMinThreeChar"), "error");
        }
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeMember", pageSize);
      this.currentPage = 1;
      this.getMemberList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getMemberList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
  